export enum CancellationReasons {
    OTHER,
    TESTING,
    REASON_1,
    REASON_2,
    REASON_3,
    REASON_4,
    REASON_5,
    REASON_6,
    REASON_7,
    REASON_8,
    REASON_9,
    REASON_10
}

